'use strict';

const AnnouncementPopup = require('./announcement.js');

function AnnouncementStickyBottomPopup () {
  AnnouncementPopup.apply(this, Array.prototype.slice.call(arguments));

  this.cls.invisible = 'slide-down';
}

AnnouncementStickyBottomPopup.prototype = new AnnouncementPopup();

module.exports = AnnouncementStickyBottomPopup;



//////////////////
// WEBPACK FOOTER
// ./_js/popups/announcement-sticky-bottom.js
// module id = 25
// module chunks = 3